module.exports = __webpack_public_path__ + "static/media/5.1c1ec974.jpg";